module.exports = __webpack_public_path__ + "static/media/EW_0013_01.7bd4efaa.png";